<template>
  <div class="home-page">
    <HomeContent />
    <Footer />
  </div>
</template>

<script>
import HomeContent from '../components/Home.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'HomePage',
  components: {
    HomeContent,
    Footer
  },
  mounted() {
    // 回顶部，保证吸附位置正确
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
  }
}
</script>

<style scoped>
/* 页脚 */
.home-page >>> .footer {
  scroll-snap-align: end;
}
</style>
